import { get, derived, writable } from 'svelte/store';
import { _, init, locale, dictionary, addMessages, getLocaleFromNavigator } from 'svelte-i18n';
import { locales } from './l10n.js';

//const MESSAGE_FILE_URL_TEMPLATE = "/assets/lang/{locale}.json";
const MESSAGE_FILE_URL_TEMPLATE = '/assets/lang/it.json';

let _activeLocale;
// Internal store for tracking network
// loading state
const isDownloading = writable(false);

// options object is now an optional param
function setupI18n(options = {}) {
	// If we're given an explicit locale, we use
	// it. Otherwise, we attempt to auto-detect
	// the user's locale.
	//const { withLocale: locale_ } = options;

	isDownloading.set(true);
	const locale_ = supported(options.withLocale || language(getLocaleFromNavigator()));
	// Initialize svelte-i18n
	init({ initialLocale: locale_ });
	// Don't re-download translation files
	if (!hasLoadedLocale(locale_)) {
		const messagesFileUrl = MESSAGE_FILE_URL_TEMPLATE.replace('{locale}', locale_);
		// Download translation file for given locale/language
		return loadJson(messagesFileUrl).then((messages) => {
			_activeLocale = locale_;
			// Configure svelte-i18n to use the locale
			addMessages(locale_, messages);
			locale.set(locale_);
			isDownloading.set(false);
		});
	}
}

// Extract the "en" bit from fully qualified
// locales, like "en-US"
function language(locale) {
	return locale.replace('_', '-').split('-')[0];
}

// Check to see if the given locale is supported
// by our app. If it isn't, return our app's
// configured fallback locale.
function supported(locale) {
	if (Object.keys(locales).includes(locale)) {
		return locale;
	} else {
		return fallbackLocale;
	}
}

const isLocaleLoaded = derived(
	[isDownloading, dictionary],
	([$isDownloading, $dictionary]) => !$isDownloading && $dictionary[_activeLocale] && Object.keys($dictionary[_activeLocale]).length > 0
);

function loadJson(url) {
	return fetch(url).then((response) => response.json());
}

function hasLoadedLocale(locale) {
	// If the svelte-i18n dictionary has an entry for the
	// locale, then the locale has already been added
	return get(dictionary)[locale];
}

// We expose the svelte-i18n _ store so that our app has
// a single API for i18n
export { _, setupI18n, isLocaleLoaded, locale };
